$(document).ready(function(){





	$('.testimonials__avatar-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.testimonials__testimonial-slider',
		dots: false,
		arrows: false,
		centerMode: true,
		centerPadding: 100,
		focusOnSelect: true,
		infinite: true
	});

	$('.testimonials__testimonial-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.testimonials__avatar-slider',
		infinite: true,
		dots: true
		// appendDots: $(".testimonials__testimonial-slider-dots")
	});


});